var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4773 20.4191C48.8656 20.5861 49.247 20.767 49.6249 20.9583C52.7523 22.5446 55.4254 24.938 57.3705 27.8671C57.8628 28.6081 58.3101 29.3839 58.7054 30.1909H64.8075C64.6792 29.8361 64.5406 29.4847 64.3949 29.1369C62.4325 24.4231 59.1665 20.4226 55.0475 17.5943C53.3729 16.4428 51.5526 15.4862 49.6284 14.7556V7.5372C50.88 7.90247 52.1004 8.34427 53.2862 8.85217C59.1249 11.3638 64.1002 15.5627 67.609 20.847C69.3634 23.4873 70.7537 26.3991 71.7037 29.5056C71.773 29.7317 71.8389 29.9579 71.9048 30.1875H77.7018C77.213 28.1385 76.5681 26.1556 75.7741 24.2492C72.8756 17.2847 68.0424 11.3638 61.9541 7.18236C58.9099 5.09162 55.5503 3.43225 51.9652 2.29817C51.199 2.05466 50.4189 1.83898 49.6318 1.64416C47.8948 1.21628 46.1127 0.913623 44.2959 0.736206V19.1528C45.7521 19.4241 47.1563 19.8486 48.4842 20.4191H48.4773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6311 38.4669H44.8819V44.1651H72.6954C72.0297 48.8197 70.3759 53.3455 67.9107 57.3218C67.1653 58.5289 66.3366 59.6839 65.4317 60.7692C64.0483 62.4251 62.5054 63.9419 60.8308 65.2916C60.1755 65.8204 59.5029 66.3213 58.8129 66.7979C56.216 68.5825 53.3522 69.9949 50.2976 70.962C50.0757 71.0316 49.8538 71.0977 49.6285 71.1638V63.9488C49.9786 63.8166 50.3219 63.6775 50.6651 63.5314C55.3007 61.538 59.2359 58.2123 62.0166 54.0274C63.1503 52.3228 64.0899 50.4756 64.8076 48.5135H58.7055C57.1452 51.6931 54.791 54.41 51.9098 56.3895C51.1817 56.8904 50.419 57.3426 49.625 57.7462C48.6646 58.2332 47.6626 58.6472 46.6224 58.9742C45.8631 59.2142 45.083 59.4056 44.2891 59.5551V77.9648C46.1058 77.7874 47.888 77.4847 49.625 77.0568C51.6394 76.5594 53.5914 75.9019 55.4671 75.0948C62.3182 72.1483 68.1361 67.2328 72.2516 61.0406C74.9005 57.0574 76.8144 52.5872 77.8129 47.8839C78.4023 45.0974 78.645 42.1926 78.645 39.347C78.645 39.0513 78.6415 38.7556 78.6346 38.4599L78.6311 38.4669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.929 10.3342C27.6918 11.423 28.2708 12.5745 28.6938 13.7608C31.4883 13.4233 34.4874 13.2111 37.6945 13.145V0.468384C31.7795 0.687546 26.2044 2.28082 21.2637 4.9386C23.6387 6.54927 25.5352 8.35475 26.9255 10.3342H26.929Z",
    fill: "url(#paint0_linear_109_343)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8804 32.2086C25.2335 36.1396 22.7094 39.4305 20.265 42.6171C18.3997 45.0452 16.6384 47.3412 15.3001 49.839C12.3912 55.2693 10.9835 60.7762 11.1499 65.9631C17.8415 73.2406 27.2409 77.9092 37.6979 78.2988V19.0449C35.2292 19.1006 32.5179 19.2641 29.6749 19.598C29.72 24.4057 28.1736 29.1264 26.8838 32.2086H26.8804Z",
    fill: "url(#paint1_linear_109_343)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6053 39.0166C17.9214 36.0005 20.1092 33.1479 21.4579 29.9265C23.0736 26.0651 23.6873 22.9725 23.7705 20.5443C17.9977 21.7167 12.0377 23.7204 6.77452 27.0531C4.65263 28.3959 2.99187 29.7387 1.72636 30.925C1.13001 33.6488 0.811035 36.4805 0.811035 39.3888C0.811035 46.4229 2.65902 53.0256 5.88 58.7273C6.6289 54.8415 8.04697 50.914 10.1169 47.049C11.684 44.1269 13.6741 41.5317 15.6019 39.02L15.6053 39.0166Z",
    fill: "url(#paint2_linear_109_343)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.12 13.7328C20.7887 11.8369 18.6182 10.0488 15.8029 8.51117C11.514 11.8682 7.93942 16.1262 5.35986 21.0069C9.68339 18.53 15.366 16.1958 22.6991 14.7173C22.498 14.3103 22.2969 13.9833 22.12 13.7328V13.7328Z",
    fill: "url(#paint3_linear_109_343)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_343",
    x1: 21.2671,
    y1: 7.11283,
    x2: 37.6979,
    y2: 7.11283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6582A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_343",
    x1: 11.1361,
    y1: 48.6701,
    x2: 1.16108,
    y2: 48.6701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6582A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_109_343",
    x1: 0.814502,
    y1: 39.6323,
    x2: 23.7705,
    y2: 39.6323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6582A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_109_343",
    x1: 5.35986,
    y1: 14.759,
    x2: 22.6991,
    y2: 14.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6582A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.827,
    height: 77.827,
    fill: "white",
    transform: "translate(0.814453 0.468384)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.7935841546b7703af03f05c9aeddd40e.svg";
export { ForwardRef as ReactComponent };